import React from 'react';
import getOr from '~/util/getOr';
import find from 'lodash/find';

import GolfCourseContainer from '~/containers/GolfCourseContainer/GolfCourseContainer';
import GolfPlayerContainer from '~/containers/GolfPlayerContainer/GolfPlayerContainer';
import ScrollMenu from '~/components/ScrollMenu/ScrollMenu';
import ScrollMenuElement from '~/components/ScrollMenuElement/ScrollMenuElement';
import StyledComponent from '~/components/Styled/Styled';
import css from './Card.scss';

interface Props {
  data: {
    node: any;
  };
  css: any;
  eventStatus: string;
}

interface State {
  selectedCourse: boolean;
  header: string;
}

class GolfCard extends React.Component<Props, State> {
  static displayName = 'GolfCard';
  constructor(props) {
    super(props);
    this.state = {
      selectedCourse: false,
      header: '',
    };
  }

  playerTabName(eventType, eventStatus) {
    if (eventType === 'STROKE_PLAY') return eventStatus === 'FINAL' ? 'LEADERS' : 'FIELD';

    return eventStatus === 'FINAL' ? 'MATCHES' : 'FIELD';
  }

  renderRoster(roster) {
    return (
      <div>
        {roster.map(elem => {
          const node = getOr(elem, 'node', {});
          return (
            <div className={css.justify}>
              <span className={`${css.subHeader} ${css.vertCenter}`}>
                <img
                  className={css.flagContainerLarge}
                  src={getOr(node, 'country.flags.0.url', '')}
                  alt={`Flag of ${node.country.name}`}
                />
                {node.teamName}
              </span>
              <span className={`${css.subHeader} ${css.vertCenter}`}>{node.scoreFloat}</span>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { data, eventStatus } = this.props;

    const extraInfo = getOr(data, 'node.extraInfo', []);
    const getInfo = label => {
      const info = find(extraInfo, { label });
      return info ? info.value : null;
    };

    const prizeCurrency = getInfo('Prize Currency');
    const prizePurse = getInfo('Prize Purse');
    const winnersShare = getInfo(`Winner's Share`);
    const fedexCup = getInfo('Fedex Cup Points');

    return (
      <div>
        <div className={css.descriptionElement}>
          {prizeCurrency && (
            <div className={css.descriptionElement}>Prize Currency: {prizeCurrency}</div>
          )}
          {prizePurse && <div className={css.descriptionElement}>Prize Purse: {prizePurse}</div>}
          {winnersShare && (
            <div className={css.descriptionElement}>Winner&apos;s Share: {winnersShare}</div>
          )}
          {fedexCup && <div className={css.descriptionElement}>Fedex Cup Points: {fedexCup}</div>}
        </div>
        <div>{this.renderRoster(getOr(data, 'node.rosters.edges', []))}</div>
        <ScrollMenu>
          <ScrollMenuElement
            onClick={() => this.setState({ selectedCourse: false })}
            selected={!this.state.selectedCourse}
            key={'field_selector'}
            name={`${this.playerTabName(data.node.eventType, eventStatus)}`}
          />
          <ScrollMenuElement
            onClick={() => this.setState({ selectedCourse: true })}
            selected={this.state.selectedCourse}
            key={'course_selector'}
            name={`COURSE`}
          />
        </ScrollMenu>
        {!this.state.selectedCourse ? (
          <GolfPlayerContainer event={data.node} eventStatus={eventStatus} />
        ) : (
          <GolfCourseContainer event={data.node} />
        )}
      </div>
    );
  }
}

export default StyledComponent(GolfCard, [css]);
